import * as styles from './styles.css';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

interface ILeadGenerationUtpProps {
  utp: {
    title: string;
    image: string;
  }[];
  whiteTheme?: boolean;
}

export const LeadGenerationUtp: React.FC<ILeadGenerationUtpProps> = ({ utp, whiteTheme = false }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['utp'], styles[device])}>
      <div className={styles['list']}>
        {utp.map(({ title, image }, key) => (
          <div className={clsx(styles['item'], whiteTheme && styles['white'])} key={key}>
            <div className={styles['item-title']}>{title}</div>
            <div className={clsx(styles['image'], styles[image])} />
          </div>
        ))}
      </div>
    </div>
  );
};
